<!--  -->
<template>
  <div class="hot-selling" v-if="goodsList.length == 5">
    <div class="top-1" @click="handleTarget(mainInfo.id)">
      <img class="cover-image" :src="mainInfo.coverImage" alt=""/>
      <span class="coming-soon-badge" v-if="mainInfo.saleStartSwitch==1&&mainInfo.saleAllow==0">即将开售 Available soon</span>
      <span class="top-range">TOP1</span>

      <div class="bottom-info-content">
        <div class="bottom-info-content-left">
          <p class="sl-ellipsis">{{ mainInfo.spuName }}</p>
          <p class="sl-ellipsis">{{ mainInfo.spuNameEn }}</p>
        </div>
        <div class="bottom-info-content-right">￥{{ mainInfo.price }}</div>
      </div>
    </div>
    <div class="extra-list fl-align-center">
      <div class="extra-item" v-for="item in extraList" :key="item.id" @click="handleTarget(item.id)">
        <img class="cover-image" :src="item.coverImage" alt=""/>
        <span class="coming-soon-badge" v-if="item.saleStartSwitch==1&&item.saleAllow==0">即将开售 Available soon</span>
        <div class="bottom-info-content" v-if="item.id">
          <div class="bottom-info-content-left">
            <p class="sl-ellipsis">{{ item.spuName }}</p>
            <p class="sl-ellipsis">{{ item.spuNameEn }}</p>
          </div>
          <div class="bottom-info-content-right">￥{{ item.price }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    goodsList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  computed: {
    extraList() {
      return this.goodsList.slice(1);
    },
    mainInfo() {
      return this.goodsList[0];
    },
  },
  methods: {
    handleTarget(id) {
      if (!id) return;
      this.$emit("handleTarget", id);
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-selling {
  display: flex;

  .top-1 {
    width: 576px;
    height: 576px;
    position: relative;
    margin-right: 14px;
    cursor: pointer;

    .cover-image {
      width: 100%;
      height: 100%;
    }

    .top-range {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      position: absolute;
      top: 46px;
      left: 24px;
    }
  }

  .bottom-info-content {
    height: 68px;
    background: rgba(43, 43, 43, 0.5);
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .bottom-info-content-left {
    font-size: 14px;
    color: #ffffff;
    line-height: 1.5;
    overflow: hidden;
  }

  .bottom-info-content-right {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
  }

  .extra-list {
    flex: 1;

    .extra-item {
      width: 280px;
      height: 280px;
      margin-bottom: 14px;
      margin-right: 14px;
      position: relative;
      cursor: pointer;

      .cover-image {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.coming-soon-badge{
  color: #ffffff;
  font-size: 14px;
  position: absolute;
  box-sizing: border-box;
  padding: 10px 15px;
  left: 20px;
  top: 20px;
  z-index: 1;
  background: rgba(197,129,29,0.58);
  border-radius: 3px;
}
</style>
